import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'my-models-table-header',
  templateUrl: './my-models-table-header.component.html',
  styleUrls: ['./my-models-table-header.component.scss']
})
export class MyModelsTableHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
